import { booksFilms } from "#site/content";
import type { MediaType, RowingRole } from "@/types";

export function getAllBooksFilms() {
  return [...booksFilms].sort((a, b) => a.title.localeCompare(b.title));
}

export function getBySlug(slug: string) {
  return booksFilms.find((bf) => bf.slug === slug);
}

export function getByRole(role: RowingRole) {
  return getAllBooksFilms().filter((bf) => bf.rowingRole === role);
}

export function getUniqueMediaTypes(): MediaType[] {
  const types = new Set<MediaType>();
  for (const bf of booksFilms) {
    types.add(bf.mediaType as MediaType);
  }
  return Array.from(types).sort();
}

export function getCount(): number {
  return booksFilms.length;
}

export function formatMediaType(type: string): string {
  switch (type) {
    case "tv-show":
      return "TV Show";
    default:
      return type.charAt(0).toUpperCase() + type.slice(1);
  }
}
